import {format as formatPhone} from 'phone-fns'
import emailRegex from 'email-regex'

cleanupPhone = (value)->
	cleanupFull(value).replace /\./g, ''

cleanupFull = (value)->
	value.replace /[\(\)-\s@\-]/g, ''

cleanupSimple = (value)->
	value.replace /[\(\)\s]/g, ''

formatPhoneValue = (value)->
	value = value.replace(/^\+/,'').replace(/^1/,'')
	return formatPhone('(NNN) NNN-NNNN', value)

validateEmail = (value)->
	if not emailRegex(exact:true).test(value)
		return "Invalid email address provided"
	
	return true

formatUrlForDisplay = (value)->
	value
		.replace 'http://', ''
		.replace 'https://', ''
		.replace /\/$/, ''

export default contactPoints = [
	type: 'phone'
	valueType: 'phone'
	icon: 'd'
	size: 37
	prefix: 'tel:'
	label: 'Phone'
	fieldType: 'tel'
	placeholder: 'Your phone number'
	valueFormatter: formatPhoneValue
	hrefFormatter: (value)-> "#{@prefix}#{cleanupPhone(value)}"
,
	type: 'whatsapp'
	valueType: 'phone'
	icon: 'j'
	size: 32
	prefix: 'https://wa.me/'
	label: 'Whatsapp'
	fieldType: 'tel'
	placeholder: 'Your phone number'
	valueFormatter: formatPhoneValue
	hrefFormatter: (value)-> "#{@prefix}#{cleanupPhone(value)}"
,
	type: 'sms'
	valueType: 'phone'
	icon: 'l'
	size: 36
	top: 1
	prefix: 'sms:'
	label: 'SMS/Text'
	fieldType: 'tel'
	placeholder: 'Your phone number'
	valueFormatter: formatPhoneValue
	hrefFormatter: (value)-> "#{@prefix}#{cleanupPhone(value)}"
,
	type: 'email'
	valueType: 'email'
	icon: 'a'
	size: 40
	prefix: 'mailto:'
	label: 'Email'
	fieldType: 'email'
	placeholder: 'Your email address'
	hrefFormatter: (value)-> "#{@prefix}#{cleanupSimple(value)}"
	validate: validateEmail
,
	type: 'website'
	icon: 'L'
	size: 29
	top: 5
	prefix: 'https://'
	label: 'Website'
	placeholder: 'Website'
	displayValue: formatUrlForDisplay
	hrefFormatter: (value)->
		if value.includes('http')
			"#{value}"
		else
			"#{@prefix}#{value}"
,
	type: 'instagram'
	icon: 'b'
	size: 34
	prefix: 'https://www.instagram.com/'
	label: 'Instagram'
	placeholder: 'Your Instagram username'
	hrefFormatter: (value)-> "#{@prefix}#{cleanupFull(value)}"
,
	type: 'snapchat'
	icon: 'p'
	size: 32
	top: 2
	prefix: 'https://www.snapchat.com/add/'
	label: 'Snapchat'
	placeholder: 'Your Snapchat username'
	hrefFormatter: (value)-> "#{@prefix}#{cleanupFull(value)}"
,
	type: 'twitter'
	icon: 'A'
	size: 29
	top: 2
	prefix: 'https://www.twitter.com/'
	label: 'Twitter'
	placeholder: 'Your Twitter handle/username'
	hrefFormatter: (value)-> "#{@prefix}#{cleanupFull(value)}"
,
	type: 'facebook'
	icon: 'u'
	size: 29
	top: 2
	prefix: 'https://www.facebook.com/'
	label: 'Facebook'
	placeholder: 'Your profile link/url'
	displayValue: (value, {name})-> value or name
	hrefFormatter: (value)->
		if value.includes(@prefix)
			"#{value}"
		else
			"#{@prefix}#{value}"
,
	type: 'linkedin'
	icon: 'z'
	size: 29
	top: 2
	prefix: 'https://www.linkedin.com/in/'
	label: 'LinkedIN'
	placeholder: 'Your profile link/url'
	displayValue: (value, {name})-> value or name
	hrefFormatter: (value)->
		if value.includes(@prefix)
			"#{value}"
		else
			"#{@prefix}#{value}"
,
	type: 'clubhouse'
	icon: 'M'
	size: 32
	top: 2
	prefix: 'https://www.clubhouse.com/'
	label: 'Clubhouse'
	placeholder: 'Your profile link/url'
	displayValue: (value, {name})-> value or name
	hrefFormatter: (value)->
		if value.includes(@prefix)
			"#{value}"
		else
			"#{@prefix}#{value}"
,
	type: 'cashapp'
	icon: 'h'
	size: 33
	prefix: 'https://cash.app/'
	label: 'Cash App'
	placeholder: 'Your Cash App username'
	hrefFormatter: (value)-> "#{@prefix}#{cleanupFull(value)}"
,
	type: 'venmo'
	icon: 'i'
	size: 66
	top: -11
	prefix: 'https://venmo.com/'
	label: 'Venmo'
	placeholder: 'Your Venmo username'
	hrefFormatter: (value)-> "#{@prefix}#{cleanupFull(value)}"
,
	type: 'zelle'
	icon: 'k'
	size: 24
	top: 8
	prefix: ''
	action: 'open-zelle-popup'
	label: 'Zelle Transfer'
	placeholder: 'Phone number or email'
	valueType: 'phone'
	hrefFormatter: (value)-> ""
,
	type: 'peymynt'
	icon: 'N'
	size: 32
	top: 2
	label: 'Peymynt'
	placeholder: 'Your Peymynt account'
	hrefFormatter: (value)-> value
,
	type: 'paypal'
	icon: 'K'
	size: 33
	# top: 8
	prefix: ''
	action: 'open-paypal-popup'
	label: 'PayPal Email'
	placeholder: 'email'
	valueType: 'email'
	hrefFormatter: (value)-> ""
,
	type: 'paypal-me'
	icon: 'K'
	size: 33
	# top: 8
	prefix: 'https://paypal.me/'
	label: 'PayPal Email'
	placeholder: 'Paypal.me handle'
	displayValue: (value, {name})-> value or name
	hrefFormatter: (value)->
		if value.includes(@prefix)
			"#{value}"
		else
			"#{@prefix}#{value}"
,
	type: 'zoom'
	icon: 'R'
	size: 36
	label: 'Zoom'
	placeholder: 'Your tagline'
	hrefFormatter: (value)-> value
,
	type: 'bam.eco'
	icon: 'O'
	size: 30
	top: 4
	label: 'BAM.ECO'
	placeholder: 'Your tagline'
	hrefFormatter: (value)-> value
,
	type: 'video'
	icon: 's'
	size: 40
	prefix: ''
	label: 'Personal Video'
	placeholder: 'Link to your video'
	displayValue: ()-> 'Watch video'
	hrefFormatter: (value)-> value
,
	type: 'address'
	icon: 't'
	size: 35
	prefix: 'https://maps.google.com/?q='
	label: 'Physical Address'
	placeholder: 'Your Address'
	hrefFormatter: (value)-> "#{@prefix}"
,
	type: 'file'
	icon: 'D'
	size: 38
	top: 2
	label: 'File'
	placeholder: 'File Link'
	displayValue: ()-> 'Open File'
	hrefFormatter: (value)-> value
,
	type: 'cash'
	icon: 'h'
	size: 33
	label: 'Cash'
	placeholder: 'Your tagline'
	hrefFormatter: (value)-> value
,
	type: '10k'
	icon: 'P'
	size: 26
	label: '10K|Cards'
	placeholder: 'Your tagline'
	hrefFormatter: (value)-> value
,
	type: 'exp-realty'
	icon: 'Q'
	size: 33
	label: 'EXP Realty'
	placeholder: 'Your tagline'
	hrefFormatter: (value)-> value
,
	type: 'trufund'
	icon: 'T'
	size: 26
	label: 'TruFund'
	placeholder: 'Your tagline'
	hrefFormatter: (value)-> value
,
	type: 'acn'
	icon: 'S'
	size: 22
	label: 'ACN'
	placeholder: 'Your tagline'
	hrefFormatter: (value)-> value
,
	type: 'clubhouselive'
	icon: 'U'
	size: 26
	label: 'Clubhouse Live'
	placeholder: 'Your tagline'
	hrefFormatter: (value)-> value
,
	type: 'googlereviews'
	icon: 'V'
	size: 30
	label: 'Google Reviews'
	placeholder: 'Your tagline'
	hrefFormatter: (value)-> value
,
	type: 'pillmethod'
	icon: 'W'
	size: 26
	label: 'Pill Method'
	placeholder: 'Your tagline'
	hrefFormatter: (value)-> value
,
	type: 'tru'
	icon: 'X'
	size: 16
	label: 'TRU'
	placeholder: 'Your tagline'
	hrefFormatter: (value)-> value
,
	type: 'applemusic'
	icon: 'Y'
	size: 32
	top: 2
	label: 'Apple Music'
	placeholder: 'Your profile link/url'
	hrefFormatter: (value)-> value
,
	type: 'spotify'
	icon: '0'
	size: 32
	top: 2
	label: 'Spotify'
	placeholder: 'Your profile link/url'
	hrefFormatter: (value)-> value
,
	type: 'breakout'
	icon: 'Z'
	size: 32
	top: 2
	label: 'Breakout'
	placeholder: 'Your profile link/url'
	hrefFormatter: (value)-> value
,
	type: 'tiktok'
	icon: '1'
	size: 32
	top: 2
	label: 'TikTok'
	placeholder: 'Your profile link/url'
	hrefFormatter: (value)-> value
,
	type: 'realestate'
	icon: '2'
	size: 30
	top: 2
	label: 'Real Estate'
	placeholder: 'Your profile link/url'
	hrefFormatter: (value)-> value
,
	type: 'referral'
	icon: '3'
	size: 30
	top: 2
	label: 'Referral'
	placeholder: ''
	hrefFormatter: (value)-> value
,
	type: 'apple'
	icon: '4'
	size: 32
	top: 0
	label: 'Apple'
	placeholder: ''
	hrefFormatter: (value)-> value
,
	type: 'telegram'
	icon: '5'
	size: 30
	top: 2
	label: 'Telegram'
	placeholder: ''
	hrefFormatter: (value)-> value
,
	type: 'bio'
	icon: '6'
	size: 30
	top: 2
	label: 'My Bio'
	placeholder: ''
	hrefFormatter: (value)-> value
,
	type: 'book'
	icon: '7'
	size: 25
	top: 5
	label: 'Book'
	placeholder: ''
	hrefFormatter: (value)-> value
,
	type: 'calendar'
	icon: '8'
	size: 30
	top: 2
	label: 'Calendar'
	placeholder: ''
	hrefFormatter: (value)-> value
,
	type: 'car'
	icon: '9'
	size: 26
	top: 4
	label: 'Car'
	placeholder: ''
	hrefFormatter: (value)-> value
,
	type: 'forsale'
	icon: '&#xe001;'
	size: 30
	top: 2
	label: 'For Sale'
	placeholder: ''
	hrefFormatter: (value)-> value
,
	type: 'money'
	icon: '&#xe002;'
	size: 30
	top: 2
	label: 'Money'
	placeholder: ''
	hrefFormatter: (value)-> value
,
	type: 'networking'
	icon: '&#xe003;'
	size: 30
	top: 2
	label: 'Networking'
	placeholder: ''
	hrefFormatter: (value)-> value
,
	type: 'podcast'
	icon: '&#xe004;'
	size: 30
	top: 2
	label: 'Podcast'
	placeholder: ''
	hrefFormatter: (value)-> value
,
	type: 'shop'
	icon: '&#xe005;'
	size: 30
	top: 2
	label: 'Shop'
	placeholder: ''
	hrefFormatter: (value)-> value
]




export getConfig = (type)->
	contactPoints.find({type})

export getPlaceholder = (type)->
	config = getConfig(type)
	return config?.placeholder

export getLabel = (type)->
	config = getConfig(type)
	return config?.label

export getHref = (type, value)->
	config = getConfig(type)
	return config?.hrefFormatter.call(config, value)

export getValue = (type, value)->
	config = getConfig(type)

	if config?.valueFormatter
		return config.valueFormatter.call(config, value)
	else
		return value

export getFieldType = (type)->
	config = getConfig(type)
	return config?.fieldType

export getSimilarValue = (type, points)->
	if valueType=determineValueType(type)
		similarPoint = do ()->
			for point in points
				if determineValueType(point.type) is valueType
					return point
		
		if similarPoint
			return similarPoint.value

export determineValueType = (type)->
	config = getConfig(type)
	return config?.valueType


